import { call, put } from 'redux-saga/effects';
import { photoCaptureGetAuthenticationDataSuccessAction, photoCaptureGetContextDataAction, photoCaptureDataFailureAction } from '../actions';
import { GuidedPhotoCapture } from '../enums';
import { GPCLoaderConstants } from '../constants';
import { PhotoCaptureAuthenticationService } from '../services';
import { getAccessTokenForAuthentication } from '../utilities';
import { getConfigurationDataAction } from "../../brandedNotification";
export function* photoCaptureGetAuthenticationSaga(action, photoCaptureAuthenticationService = new PhotoCaptureAuthenticationService()) {
    var _a;
    const { coCode, contextId, brandedNotificationInputs } = action.payload;
    const accessToken = getAccessTokenForAuthentication();
    try {
        const response = yield call({
            context: photoCaptureAuthenticationService,
            fn: photoCaptureAuthenticationService.photoCaptureGetAuthenticationData
        }, coCode, contextId, accessToken);
        yield put(photoCaptureGetAuthenticationDataSuccessAction(response.result));
        const parsedAuthToken = JSON.parse(response.result.authToken);
        if (parsedAuthToken.access_token) {
            localStorage.setItem(GPCLoaderConstants.ACCESS_TOKEN, parsedAuthToken.access_token);
            sessionStorage.setItem(GPCLoaderConstants.ACCESS_TOKEN, parsedAuthToken.access_token);
        }
        yield brandedNotificationInputs && put(getConfigurationDataAction(brandedNotificationInputs, coCode, ''));
        yield response.result.authToken &&
            ((_a = response.result.workItemStatus) === null || _a === void 0 ? void 0 : _a.toUpperCase()) === GuidedPhotoCapture.TASK_STATUS_OPENED &&
            put(photoCaptureGetContextDataAction(coCode, contextId));
    }
    catch (error) {
        yield put(photoCaptureDataFailureAction(error.toString()));
    }
}
//# sourceMappingURL=photoCaptureGetAuthenticationSaga.js.map